<template>
  <f7-page class="main-productive-activity-line">
    <template #fixed>
      <TheNavbar
        nav-title="Control de actividades productivas en línea"
        back-btn-enable
      />
    </template>

    <f7-block class="no-margin padding-half">
      <!-- Search bar navigation -->
      <div class="content-header-activity-line">
        <div class="content-logo-company padding-right-half">
          <!-- <h3 class="color-dark-blue">Logo de Empresa</h3> -->
          <img
            width="auto"
            height="44"
            alt="iconLogo"
            :src="logoClient"
          >
        </div>
        <div class="content-search-entity">
          <UCSearchEntityERP
            :title="$t('searchEntity.line.title.searchProductionLine')"
            :placeholder="$t('searchEntity.line.placeholder.codeLine')"
            :search-text="$t('searchEntity.line.searchText')"
            :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
            :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
            :default-etities-list="lineasProduccion"
            :property-entity-shown-input="['Codigo', 'Nombre']"
            :property-entity-shown-list-title="['Codigo']"
            :property-entity-shown-list-subtitle="['Nombre']"
            :next-and-previous-buttons-shown="true"
            :disabled="disabledElementFrm"
            @selection="EventSelectedProductionLine"
          />
          <!-- End Search bar navigation -->
        </div>
        <div class="content-logo-hispatec">
          <div class="text-align-right padding-right margin-left">
            <img
              width="auto"
              height="44"
              alt="iconLogo"
              :src="LOGO_HISPATEC"
            >
          </div>
        </div>
      </div>
      <div class="content-grid">
        <!-- LEFT  Condicional que haga que cuando estás en móvil muestra un botón LEF PANEL -->

        <div v-if="isMobile()">
          <f7-row>
            <f7-col>
              <f7-button
                outline
                panel-open="#panel-activity"
              >
                Actividades
                <f7-badge class="margin-left-half">
                  {{ totalActivitysLine }}
                </f7-badge>
              </f7-button>
            </f7-col>
            <f7-col>
              <f7-button
                fill
                panel-open="#panel-new-activity"
              >
                Generar Marcajes
              </f7-button>
            </f7-col>
          </f7-row>
          <f7-panel
            id="panel-activity"
            left
            cover
            container-el="#panel-page-activity"
          >
            <f7-page>
              <!-- Close Button -->
              <f7-link
                class="panel-close justify-content-flex-end"
                panel-close
              >
                <img
                  alt="iconClose"
                  src="@/static/icons/ic_close.svg"
                >
              </f7-link>
              <div class="card card-outline">
                <UCEntitySelection
                  class="no-padding"
                  header-title="Actividades"
                  :card-title-prop="['Nombre']"
                  :entity-list="activitiesProductionWithInterventions"
                  :show-preload="showPreloadActivitiesLine"
                  maximum-text-length="15"
                  @change-selected="ChangeActivitieSelected"
                  @checked-all="GetCheckedActivity"
                />
                <UCEntitySelection
                  v-if="showPresenceShifts"
                  class="no-padding"
                  header-title="Turnos"
                  :card-title-prop="['Descripcion']"
                  :entity-list="turnWithInterventions"
                  :show-preload="showPreloadTurnLine"
                  @change-selected="ChangeTurnSelected"
                  @checked-all="GetCheckedTurn"
                />
                <!-- Autorizaciones Aseos -->
                <div class="content-aseos">
                  <PCProductionLineOutputAuthorizations
                    v-if="selectedProductionLine != null && selectedProductionLine.ZonasAutorizadasAseos.length > 0"
                    ref="PCProductionLineOutputAuthorizations"
                    :selected-production-line="selectedProductionLine"
                    @authorized-worker-output="GetMainData(true)"
                  />
                </div>
              </div>
            </f7-page>
          </f7-panel>
        </div>
        <div
          v-else
          class="sticky scroll-pane"
        >
          <UCEntitySelection
            class="no-padding"
            header-title="Actividades"
            :card-title-prop="['Nombre']"
            :entity-list="activitiesProductionWithInterventions"
            :show-preload="showPreloadActivitiesLine"
            @change-selected="ChangeActivitieSelected"
            @checked-all="GetCheckedActivity"
          />
          <UCEntitySelection
            v-if="showPresenceShifts"
            class="no-padding"
            header-title="Turnos"
            :card-title-prop="['Descripcion']"
            :entity-list="turnWithInterventions"
            :show-preload="showPreloadTurnLine"
            @change-selected="ChangeTurnSelected"
            @checked-all="GetCheckedTurn"
          />
          <!-- Autorizaciones Aseos -->
          <div class="content-aseos">
            <PCProductionLineOutputAuthorizations
              v-if="selectedProductionLine != null && selectedProductionLine.ZonasAutorizadasAseos.length > 0"
              ref="PCProductionLineOutputAuthorizations"
              :selected-production-line="selectedProductionLine"
              @authorized-worker-output="GetMainData(false)"
            />
          </div>
        </div>

        <!-- Center -->
        <div>
          <div class="card card-outline">
            <div class="card-header padding-right-half">
              Trabajadores Activos
              <div class="actions-container">
                <f7-link
                  class="sorter-container"
                  :class="{
                    'disabled-element':
                      disabledElementFrm
                      || numberOfWorkersSelected === 0
                      || numberOfWorkersSelected > 1,
                  }"
                  @click="RequestWorkersOutputLine()"
                >
                  WC
                </f7-link>
                <UCSortPopover
                  :sort-field-list="sortFieldList"
                  :disabled="disabledElementFrm"
                  class="padding-right-half"
                  @on-change="EventChangeSortField"
                />
                <f7-link
                  class="animated-spin"
                  :class="{
                    'disabled-element': showPreloadWorkerLine || showPreloadActivitiesLine,
                  }"
                  @click="GetMainData(false)"
                >
                  <img
                    alt="iconRefresh"
                    src="@/static/icons/ic_refresh_blue.svg"
                  >
                </f7-link>
              </div>
            </div>
            <div class="card-content card-content-padding">
              <f7-row>
                <!-- CENTER TOP -->
                <f7-col>
                  <div class="content-title-select">
                    <div class="content-title-select__input">
                      <label class="checkbox">
                        <input
                          v-model="checkAllWorkerElementProduction"
                          type="checkbox"
                        >
                        <i class="icon-checkbox" />
                      </label>
                      Seleccionar Todos
                    </div>
                    <div class="content-title-select__total">
                      <f7-badge>
                        {{ totalWorkersLineShown }}
                      </f7-badge>
                    </div>
                    <!-- Filtro de búsqueda -->
                    <f7-list
                      class="input-filter"
                    >
                      <f7-list-input
                        outline
                        label="Filtrar trabajadores.."
                        floating-label
                        type="text"
                        placeholder="Nombre o código de trabajador..."
                        clear-button
                        @input="filterWorkerText = $event.target.value"
                      />
                    </f7-list>
                  </div>
                  <UCPreload :show="showPreloadWorkerLine" />
                  <div class="content-list-checkbox content-list-checkbox-scroll">
                    <!-- <pre> {{ workerElementProduction }} </pre> -->
                    <div
                      v-for="d in filteredWorkerElements"
                      :key="d.Id"
                      no-gap
                    >
                      <div
                        v-if="d.ActividadProduccion.checked
                          && ((d.TurnoHorario != null && d.TurnoHorario.checked)
                            || d.TurnoHorario == null)"
                        class="content-list-checkbox-item"
                        :class="{
                          'incidence': d.lastRecordError === true ? true : false,
                          'out-of-line': d.FueraDeLinea === true ? true : false,
                        }"
                      >
                        <label class="checkbox">
                          <input
                            :checked="d.checked"
                            type="checkbox"
                            @change="d.checked = !d.checked"
                          >
                          <i class="icon-checkbox" />
                        </label>
                        <div @click="ShowDetailWorker(d.Trabajador, d.Incidencias)">
                          <div class="content-list-checkbox-item__details">
                            <div>
                              <img
                                v-if="d.Trabajador.Sujeto.ImagenPerfil == null"
                                alt="iconUser"
                                src="@/static/icons/ic_user.svg"
                                class="avatar-round"
                              >
                              <img
                                v-if="d.Trabajador.Sujeto.ImagenPerfil != null"
                                :src="d.Trabajador.Sujeto.ImagenPerfil.Archivo"
                                alt="iconAvatar"
                                class="avatar-round"
                              >
                            </div>
                            <div
                              class="content-list-checkbox-item__details--title"
                            >
                              {{
                                TextMaximumLength(
                                  d.Trabajador.Sujeto.NombreCompleto,
                                  40,
                                )
                              }}
                              <br>
                              <span>
                                {{
                                  d.Trabajador.Codigo
                                }}
                              </span>

                              <div
                                class="content-list-checkbox-item__details--subtitle"
                              >
                                {{ d.ActividadProduccion.Nombre }}
                              </div>
                              <div
                                v-if="d.TurnoHorario != null"
                                class="content-list-checkbox-item__details--subtitle"
                              >
                                {{ d.TurnoHorario.Descripcion }}
                              </div>
                              <span
                                v-if="d.lastRecordError && d.lastRecordErrorText"
                                class="span-text-error"
                              >
                                {{ d.lastRecordErrorText }}
                              </span>
                            </div>
                          </div>
                          <div class="content-list-checkbox-item__warning">
                            <div v-if="d.Incidencias.length > 0">
                              <img
                                alt="iconWarning"
                                src="@/static/icons/ic_warning.svg"
                              >
                            </div>

                            <div
                              class="content-list-checkbox-item__time"
                              @click="ShowDetailWorker(d.Trabajador)"
                            >
                              <div class="padding-right-half">
                                <img
                                  v-if="d.FueraDeLinea"
                                  alt="iconWcGray"
                                  src="@/static/icons/ic_wc_gray.svg"
                                >
                              </div>
                              <div>
                                <!-- <img
                                  v-if="d.FueraDeLinea"
                                  alt="iconWcGray"
                                  src="@/static/icons/ic_wc_gray.svg"
                                > -->
                                {{ FormatTime(d.FechaInicio, 'HH:mm') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Indicador de ultimo marcaje erroneo -->
                      </div>
                    </div>
                  </div>
                </f7-col>
              </f7-row>
            </div>
          </div>
        </div>
        <!-- center -->

        <!-- RIGHT (Generar Marcaje)
        Condicional que haga que cuando estás en móvil muestra un botón LEF PANEL -->

        <div v-if="isMobile()">
          <f7-panel
            id="panel-new-activity"
            right
            cover
            container-el="#panel-page-new-activity"
          >
            <!-- Close Button -->
            <f7-link
              class="panel-close justify-content-flex-start"
              panel-close
            >
              <img
                alt="iconClose"
                src="@/static/icons/ic_close.svg"
              >
            </f7-link>
            <div class="content-new-activity">
              <div class="card card-outline">
                <div class="card-header">
                  Generar Marcaje
                </div>
                <div
                  class="
                    card-content card-content-padding
                    no-padding-top
                    margin-top-half
                  "
                >
                  <div>
                    <UCSearchEntityERP
                      :title="$t('searchEntity.productionActivity.title.productionActivitySearch')"
                      :placeholder="$t('searchEntity.productionActivity.placeholder.productionActivityCode')"
                      :search-text="$t('searchEntity.productionActivity.searchText')"
                      :search-cancellation-text="$t('searchEntity.productionActivity.searchCancellationText')"
                      :search-not-found-text="$t('searchEntity.productionActivity.searchNotFoundText')"
                      :end-point-for-code-search="ActivityCodeSearch"
                      :end-point-for-list="ActivityList"
                      :property-entity-shown-input="['Codigo', 'Nombre']"
                      :property-entity-shown-list-title="['Codigo']"
                      :property-entity-shown-list-subtitle="['Nombre']"
                      :disabled="
                        disabledElementFrm || numberOfWorkersSelected === 0
                      "
                      @selection="EventSelectedProductionActivityNewRecord"
                    />
                  </div>
                  <div class="content-new-activity__datetime">
                    <UCDatePicker
                      id="date-picker-form"
                      :title="$t('common.date')"
                      :disabled="
                        disabledElementFrm || numberOfWorkersSelected === 0
                      "
                      @onchange="ChangedDateNewRecordWorkers"
                    />
                    <UCTimePicker
                      id="time-picker-from"
                      :title="$t('common.hour')"
                      template="P2"
                      :show-seconds="true"
                      :disabled="
                        disabledElementFrm || numberOfWorkersSelected === 0
                      "
                      @onchange="ChangeTimeNewRecordWorkers"
                    />
                  </div>
                  <div>
                    <f7-button
                      :disabled="
                        disabledElementFrm || numberOfWorkersSelected === 0
                      "
                      fill
                      color="greendark"
                      class="margin-top-half"
                      @click="NewRecordSelectedWorker()"
                    >
                      GENERAR MARCAJES
                    </f7-button>
                    <f7-row>
                      <f7-col>
                        <f7-button
                          :disabled="
                            disabledElementFrm || numberOfWorkersSelected === 0
                          "
                          fill
                          small
                          color="oliva"
                          class="margin-top-half"
                          @click="NewRecordEndOfActivitySelectedWorker()"
                        >
                          FIN ACTIVIDAD
                        </f7-button>
                      </f7-col>
                    </f7-row>
                  </div>
                </div>
              </div>
              <div class="card card-outline margin-top">
                <div class="card-header">
                  Otras Opciones
                </div>
                <div
                  class="
                    card-content card-content-padding
                    no-padding-top
                    margin-top-half
                  "
                >
                  <f7-button
                    fill
                    color="oliva"
                    class="margin-top-half"
                    @click="OpenNewWorkerRecord()"
                  >
                    Nuevo marcaje manual
                  </f7-button>
                  <f7-col>
                    <f7-button
                      :disabled="
                        disabledElementFrm || numberOfWorkersSelected === 0
                      "
                      fill
                      small
                      color="orange"
                      class="margin-top-half"
                      @click="popupShowChangeProductionLineWorkers = true"
                    >
                      CAMBIAR LÍNEA
                    </f7-button>
                    <f7-button
                      :disabled="
                        disabledElementFrm || selectedProductionLine == null
                      "
                      fill
                      small
                      color="darkgray"
                      class="margin-top-half"
                      @click="RecalculateCurrentAndPreviousDays"
                    >
                      RECALCULAR JORNADA ANTERIOR Y ACTUAL
                    </f7-button>
                  </f7-col>
                </div>
              </div>
            </div>
          </f7-panel>
        </div>
        <div v-else>
          <div class="content-new-activity sticky">
            <div class="card card-outline">
              <div class="card-header padding-right-half">
                Generar Marcaje
                <div class="actions-container">
                  <f7-link
                    v-if="permitirReiniciarServicioCapturaMarcajesAPP"
                    class="sorter-container padding-right-half"
                    :class="{
                      'disabled-element': disabledElementFrm,
                    }"
                    @click="RequestCaptureServiceRestart()"
                  >
                    RESET SRV.CAPTURA
                  </f7-link>
                </div>
              </div>
              <div
                class="
                  card-content card-content-padding
                  no-padding-top
                  margin-top-half
                "
              >
                <div>
                  <UCSearchEntityERP
                    :title="$t('searchEntity.productionActivity.title.productionActivitySearch')"
                    :placeholder="$t('searchEntity.productionActivity.placeholder.productionActivityCode')"
                    :search-text="$t('searchEntity.productionActivity.searchText')"
                    :search-cancellation-text="$t('searchEntity.productionActivity.searchCancellationText')"
                    :search-not-found-text="$t('searchEntity.productionActivity.searchNotFoundText')"
                    :end-point-for-code-search="ActivityCodeSearch"
                    :end-point-for-list="ActivityList"
                    :property-entity-shown-input="['Codigo', 'Nombre']"
                    :property-entity-shown-list-title="['Codigo']"
                    :property-entity-shown-list-subtitle="['Nombre']"
                    :disabled="
                      disabledElementFrm || numberOfWorkersSelected === 0
                    "
                    @selection="EventSelectedProductionActivityNewRecord"
                  />
                </div>
                <div class="content-new-activity__datetime">
                  <UCDatePicker
                    id="1"
                    :title="$t('common.date')"
                    :disabled="
                      disabledElementFrm || numberOfWorkersSelected === 0
                    "
                    @onchange="ChangedDateNewRecordWorkers"
                  />
                  <UCTimePicker
                    id="time-picker-from"
                    :title="$t('common.hour')"
                    template="P2"

                    :show-seconds="true"
                    :disabled="
                      disabledElementFrm || numberOfWorkersSelected === 0
                    "
                    @onchange="ChangeTimeNewRecordWorkers"
                  />
                </div>
                <div>
                  <f7-button
                    :disabled="
                      disabledElementFrm || numberOfWorkersSelected === 0
                    "
                    fill
                    color="greendark"
                    class="margin-top-half"
                    @click="NewRecordSelectedWorker()"
                  >
                    GENERAR MARCAJES
                  </f7-button>
                  <f7-row>
                    <f7-col>
                      <f7-button
                        :disabled="
                          disabledElementFrm || numberOfWorkersSelected === 0
                        "
                        fill
                        small
                        color="oliva"
                        class="margin-top-half"
                        @click="NewRecordEndOfActivitySelectedWorker()"
                      >
                        FIN ACTIVIDAD
                      </f7-button>
                    </f7-col>
                  </f7-row>
                </div>
              </div>
            </div>
            <div class="card card-outline margin-top">
              <div class="card-header">
                Otras Opciones
              </div>
              <div
                class="
                  card-content card-content-padding
                  no-padding-top
                  margin-top-half
                "
              >
                <f7-button
                  fill
                  color="oliva"
                  class="margin-top-half"
                  @click="OpenNewWorkerRecord()"
                >
                  Nuevo marcaje manual
                </f7-button>
                <f7-col>
                  <f7-button
                    :disabled="
                      disabledElementFrm || numberOfWorkersSelected === 0
                    "
                    fill
                    small
                    color="orange"
                    class="margin-top-half"
                    @click="popupShowChangeProductionLineWorkers = true"
                  >
                    CAMBIAR LÍNEA
                  </f7-button>
                  <f7-button
                    :disabled="
                      disabledElementFrm || selectedProductionLine == null
                    "
                    fill
                    small
                    color="darkgray"
                    class="margin-top-half"
                    @click="RecalculateCurrentAndPreviousDays"
                  >
                    RECALCULAR JORNADA ANTERIOR Y ACTUAL
                  </f7-button>
                </f7-col>
              </div>
            </div>
          </div>
          <!-- End of RIGHT (Generar Marcaje) -->
        </div>
      </div>
      <!-- POPUP DETALLE MARCAJES TRABAJADOR -->
      <f7-popup
        :opened="popupShowDetailWorkerRecords"
        @popup:closed="ClosePopupDetailWorkerRecords"
      >
        <f7-page>
          <f7-navbar
            sliding
            class="at-navbar secondary-navbar"
            title="Detalle Marcajes Trabajador"
          >
            <f7-nav-right>
              <f7-link
                popup-close
                icon="icon-close"
                @click="popupShowDetailWorkerRecords = false"
              />
            </f7-nav-right>
          </f7-navbar>
          <div>
            <UCPreload :show="popupShowDetailWorkerRecordsShowPreload" />

            <!-- Datos Trabajador Seleccionado -->
            <div
              v-for="inc in selectedWorkerIncidences"
              :key="inc.Id"
              class="popup-detalle-marcajes-errores"
            >
              <img
                alt="iconWarning"
                src="@/static/icons/ic_warning.svg"
              >
              <span>{{ inc.Descripcion }}</span>
            </div>
            <div>
              <PCWorkerDetailsRecords
                v-if="popupShowDetailWorkerRecords && selectedWorker != null"
                :worker-selected-default="selectedWorker"
                :selected-line="selectedProductionLine"
                :show-crud-options="true"
                :show-selector-consultation-date="true"
                :open-new-record-in-popup="true"
                :show-time-seconds="true"
                @on-success="SuccessPcWorkerDetails"
                @record-removed="RecordRemoved"
              />
            </div>
          </div>
        </f7-page>
      </f7-popup>
    </f7-block>

    <!-- Action Confirmación acciones del formulario -->
    <UCConfirmation ref="confirmationComponent" />

    <!-- POPUP CAMBIAR TRABAJADORES DE LINEA PRODUCCIÓN -->
    <f7-popup
      class=""
      :opened="popupShowChangeProductionLineWorkers"
      @popup:closed="popupShowChangeProductionLineWorkers = false"
    >
      <f7-navbar
        sliding
        class="at-navbar secondary-navbar"
        title="Cambiar trabajadores de linea de producción"
      >
        <f7-nav-right>
          <f7-link
            popup-close
            icon="icon-close"
            @click="popupShowChangeProductionLineWorkers = false"
          />
        </f7-nav-right>
      </f7-navbar>
      <div>
        <PCChangeWorkersProductionLine
          v-if="popupShowChangeProductionLineWorkers"
          :worker-element-production="workerElementProductionSelected"
          :restrict-day-marking="true"
          template-for-time-picker="P2"
          :seconds-on-time-picker="true"
          @on-success="popupShowChangeProductionLineWorkers = false; GetMainData(false);"
          @on-error="popupShowChangeProductionLineWorkers = false; SetItemLastRecordError($event);"
        />
      </div>
    </f7-popup>

    <!-- POPUP BUSQUEDA TRABAJADOR PARA NUEVO MARCAJE -->
    <f7-popup
      class="new-mark-worker-popup"
      :opened="popupShowNewMarkingForDifferentWorker"
      @popup:closed="popupShowNewMarkingForDifferentWorker = false"
    >
      <f7-navbar
        sliding
        class="at-navbar secondary-navbar"
        title="Nuevo marcaje para trabajador"
      >
        <f7-nav-right>
          <f7-link
            popup-close
            icon="icon-close"
            @click="popupShowNewMarkingForDifferentWorker = false"
          />
        </f7-nav-right>
      </f7-navbar>
      <div class="popup-new-record-workers">
        <PCNewWorkerRecord
          v-if="popupShowNewMarkingForDifferentWorker"
          template="P2"
          :restrict-day-marking="true"
          :default-selected-line="selectedProductionLine"
          :reset-when-generating-new-record="true"
          :seconds-on-time-picker="true"
          :show-seconds="true"
          @on-success="GetMainData(false)"
          @on-cancel="popupShowNewMarkingForDifferentWorker = false"
        />
      </div>
    </f7-popup>
  </f7-page>
</template>

<script>
import { mapState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCPreload from '@/components/common/UCPreload.vue';
import APIErp, { callGetPhotosProfileSubjects, callLineWorkersToDate } from '@/js/services/APIErp';
import { HiDialog, HiNotification } from '@/js/common/HINotificationSupport';
import { showToast } from '@/js/common/HiNotificationExSupport';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCTimePicker from '@/components/common/UCTimePicker.vue';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import PCWorkerDetailsRecords from '@/components/presence/workerRecords/PCWorkerDetailsRecords.vue';
import PCNewWorkerRecord from '@/components/presence/workerRecords/PCNewWorkerRecord.vue';

import {
  HiDateTimeSupport,
  HiStringSupport,
} from '@/js/common/HIConversionSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import PCChangeWorkersProductionLine from '@/components/production/workerElementProduction/PCChangeWorkersProductionLine.vue';
import PCProductionLineOutputAuthorizations from '@/components/production/workerElementProduction/PCProductionLineOutputAuthorizations.vue';
import UCSortPopover from '@/components/common/UCSortPopover.vue';
import UCEntitySelection from '@/components/common/UCEntitySelection.vue';
import { LOGO_HISPATEC } from '@/js/common/constants';
import { sleep } from '@/js/utils/sleep';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

/** @import { MarcajeCerco } from '@erpagroapp/types' */

export default {
  name: 'FrmProductiveActivityLine',
  components: {
    UCSearchEntityERP,
    UCPreload,
    TheNavbar,
    UCTimePicker,
    UCDatePicker,
    UCConfirmation,
    UCSortPopover,
    UCEntitySelection,
    PCWorkerDetailsRecords,
    PCChangeWorkersProductionLine,
    PCNewWorkerRecord,
    PCProductionLineOutputAuthorizations,
  },

  data() {
    return {
      logoClient: null,
      selectedActivityNewRecords: null,
      selectedProductionLine: null,
      workerElementProduction: [],
      activitiesProductionWithInterventions: [],
      turnWithInterventions: [],
      dateNewRecordsWorkers: null,
      timeNewRecordsWorkers: null,
      showPreloadWorkerLine: false,
      showPreloadActivitiesLine: false,
      showPreloadTurnLine: false,
      popupShowDetailWorkerRecords: false,
      popupShowDetailWorkerRecordsShowPreload: false,
      selectedWorker: null,
      popupShowChangeProductionLineWorkers: false,
      // Elementos de ordenación de la lista de trabajadorElementoProduccion
      sortFieldList: [],
      // Almacena el campo por el que esta ordenada la lista de trabajadorElementoProduccion
      sortFieldSelected: null,
      // Deshabilita los componentes del formulario que no deben
      // ser marcados mientras no exista linea de producción seleccionada.
      disabledElementFrm: false,
      popupShowNewMarkingForDifferentWorker: false,
      automaticUpdateInterval: 120, // Segundos en los actualiza la lista de workerElementProduction
      updateTimer: null, // temporizador de actualizaciones
      automaticUpdate: true, // Controla si se quieren actualizaciones automaticas.
      incidences: [], // incidencias de marcajes
      selectedWorkerIncidences: [], // incidencias del trabajador seleccionado
      automaticUpdateEnabled: false, // Controla si se quieren actualizaciones automaticas. Hablado con Dani se quitan las actualizaciones temporalmente.
      filterWorkerText: '', // Texto de filtro los trabajadores mostrados.
      lineasProduccion: null,
      LOGO_HISPATEC,
      permitirReiniciarServicioCapturaMarcajesAPP: useParamRef('PermitirReiniciarServicioCapturaMarcajesAPP'),
      showPresenceShifts: useParamRef('MostrarTurnosPresencia'),
      logoApp: useSettingRef('App.Logo'),
    };
  },
  computed: {
    ...mapState(useTraceabilityStore, ['getLineasProduccion']),

    checkAllWorkerElementProduction: {
      get() {
        if (this.workerElementProduction.length === 0) {
          return false;
        }
        for (let i = 0; i < this.workerElementProduction.length; i += 1) {
          if (!this.workerElementProduction[i].checked) {
            return false;
          }
        }
        return true;
      },
      set(value) {
        this.workerElementProduction.forEach((item) => {
          item.checked = value;
        });
      },
    },
    checkAllActivitysLine: {
      get() {
        if (this.activitiesProductionWithInterventions.length === 0) {
          return false;
        }
        for (
          let i = 0;
          i < this.activitiesProductionWithInterventions.length;
          i += 1
        ) {
          if (!this.activitiesProductionWithInterventions[i].checked) {
            return false;
          }
        }
        return true;
      },
      set(value) {
        this.activitiesProductionWithInterventions.forEach((item) => {
          item.checked = value;
        });
        // Marcamos tambien todas las actividades de producción de los trabajadorElementoProduccion
        this.workerElementProduction.forEach((item) => {
          item.ActividadProduccion.checked = value;
        });
      },
    },
    checkAllTurnLine: {
      get() {
        if (this.turnWithInterventions.length === 0) {
          return false;
        }
        for (
          let i = 0;
          i < this.turnWithInterventions.length;
          i += 1
        ) {
          if (!this.turnWithInterventions[i].checked) {
            return false;
          }
        }
        return true;
      },
      set(value) {
        this.turnWithInterventions.forEach((item) => {
          item.checked = value;
        });
        // Marcamos tambien todas los turnos de los trabajadorElementoProduccion
        this.workerElementProduction.forEach((item) => {
          if (item.TurnoHorario != null) {
            item.TurnoHorario.checked = value;
          }
        });
      },
    },
    numberOfWorkersSelected() {
      return this.workerElementProduction.filter(
        (element) => element.checked === true
          && element.ActividadProduccion.checked === true
          && (element.TurnoHorario == null || (element.TurnoHorario !== null && element.TurnoHorario.checked === true)),
      ).length;
    },
    totalWorkersLineShown() {
      return this.workerElementProduction.filter(
        (element) => element.checked
          && element.ActividadProduccion.checked
          && (element.TurnoHorario == null || (element.TurnoHorario !== null && element.TurnoHorario.checked === true)),
        /* && element.TurnoHorario != null
          && element.TurnoHorario.checked === true */
      ).length;
    },
    totalActivitysLine() {
      return this.activitiesProductionWithInterventions.length;
    },
    workerElementProductionSelected() {
      return this.workerElementProduction.filter(
        (element) => element.checked
          && element.ActividadProduccion.checked
          && (element.TurnoHorario == null || (element.TurnoHorario !== null && element.TurnoHorario.checked === true)),
        /* && element.ActividadProduccion.checked
          && element.TurnoHorario !== null
          && element.TurnoHorario.checked === true, */
      );
    },
    filteredWorkerElements() {
      const { filterWorkerText } = this;

      if (!filterWorkerText) {
        return this.workerElementProduction;
      }

      return this.workerElementProduction.filter(
        (d) => d.Trabajador.Sujeto.NombreCompleto.toUpperCase().includes(filterWorkerText.toUpperCase())
          || d.Trabajador.Codigo.toUpperCase().includes(filterWorkerText.toUpperCase()),
      );
    },
  },

  mounted() {
    this.StartForm();
  },
  beforeUnmount() {
    this.RemoveIntervalAutomaticUpdates();
  },

  methods: {
    StartForm() {
      Log(this, this.StartForm.name);
      this.logoClient = this.GetLogo();
      this.dateNewRecordsWorkers = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD',
      );
      this.timeNewRecordsWorkers = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'HH:mm',
      );
      this.sortFieldList = [
        {
          Name: 'Fecha',
          AssociatedFilterProperty: 'FechaInicio',
        },
        {
          Name: 'Trabajadores',
          AssociatedFilterProperty: 'Trabajador.Sujeto.NombreCompleto',
        },
        {
          Name: 'Actividades',
          AssociatedFilterProperty: 'ActividadProduccion.Nombre',
        },
      ];
      [this.sortFieldSelected] = this.sortFieldList; // Ordenación por defecto
      this.NewUpdateTimer();
      this.lineasProduccion = this.getLineasProduccion;
    },

    GetLogo() {
      return this.logoApp || LOGO_HISPATEC;
    },
    EventSelectedProductionActivityNewRecord(objActivity) {
      Log(this, this.EventSelectedProductionActivityNewRecord.name);
      this.selectedActivityNewRecords = objActivity;
    },
    async EventSelectedProductionLine(objProductionLine) {
      Log(this, this.EventSelectedProductionLine.name);
      this.selectedProductionLine = objProductionLine;
      await this.GetMainData(false);
    },
    async SuccessPcWorkerDetails() {
      await this.GetMainData(false);
      this.ClosePopupDetailWorkerRecords();
    },
    async GetMainData(automaticUpdate) {
      Log(this, this.GetMainData.name);
      const outputAuthorizations = this.$refs.PCProductionLineOutputAuthorizations;
      if (outputAuthorizations) {
        outputAuthorizations.Clear();
      }
      this.workerElementProduction = [];
      this.activitiesProductionWithInterventions = [];
      this.turnWithInterventions = [];
      if (this.selectedProductionLine != null) {
        await this.GetLineWorkers();
        this.GetPhotosProfileSubjects();
        this.GetMarkingIncidents(this.selectedProductionLine.Id);
        // this.GetProductionActivitiesXProductionLineToDate();
        this.activitiesProductionWithInterventions = this.GetLineProductionActivities(this.workerElementProduction);
        this.GetCheckedActivity(true);
        this.checkAllActivitysLine = true; // Seleccionamos todos.
        this.turnWithInterventions = this.GetLineTurns(this.workerElementProduction);
        this.GetCheckedTurn(true);
        this.checkAllTurnLine = true; // Seleccionamos todos.
        await sleep(200);
        this.$refs.PCProductionLineOutputAuthorizations?.Refresh();
      } else {
        /*
        const outputAuthorizations = this.$refs.PCProductionLineOutputAuthorizations;

        if (outputAuthorizations) {
          outputAuthorizations.Clear();
        }
        */
      }

      // Al tratarse de una actualización manual restablecemos el timer.
      if (!automaticUpdate) {
        this.RemoveIntervalAutomaticUpdates();
        this.NewUpdateTimer();
      }
    },

    GetCheckedActivity(value) {
      this.workerElementProduction.forEach((item) => {
        item.ActividadProduccion.checked = value;
      });
    },

    GetCheckedTurn(value) {
      this.workerElementProduction.forEach((item) => {
        if (item.TurnoHorario != null) {
          item.TurnoHorario.checked = value;
        }
      });
    },

    GetLineProductionActivities(workerElementProduction) {
      Log(this, this.GetLineProductionActivities.name);
      const result = [];
      workerElementProduction.forEach((item) => {
        if (item.ActividadProduccion != null) {
          result.push(
            item.ActividadProduccion,
          );
        }
      });
      return result;
    },

    GetLineTurns(workerElementProduction) {
      Log(this, this.GetLineTurns.name);
      const result = [];
      workerElementProduction.forEach((item) => {
        if (item.TurnoHorario != null) {
          result.push(
            item.TurnoHorario,
          );
        }
      });
      return result;
    },

    TextMaximumLength(text, numCharacters) {
      return HiStringSupport.TextMaximumLength(text, numCharacters);
    },

    FormatTime(dateTime, format) {
      return HiDateTimeSupport.FormatDateTime(dateTime, format);
    },
    /**
     * Obtiene las incidencias de marcajes de la linea de produccion en la
     * que se encuentre.
     */
    GetMarkingIncidents(idLineaProduccion) {
      Log(this, this.GetMarkingIncidents.name);
      const self = this;
      const newDate = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD HH:mm:ss',
      );
      APIErp.callMarkingIncidents(idLineaProduccion, newDate)
        .then((result) => {
          self.incidences = result.data;
          self.AddIncidencesToWorkers();
        }).catch(() => {
          // LogError(this, this.GetMarkingIncidents.name, error);

        });
    },
    AddIncidencesToWorkers() {
      Log(this, this.AddIncidencesToWorkers.name);
      for (let i = 0; i < this.workerElementProduction.length; i += 1) {
        this.workerElementProduction[i].Incidencias = [];
      }
      for (let i = 0; i < this.incidences.length; i += 1) {
        const element = this.incidences[i];

        for (let j = 0; j < this.workerElementProduction.length; j += 1) {
          const element2 = this.workerElementProduction[j];
          if (element.Trabajador.Id === element2.Trabajador.Id) {
            this.workerElementProduction[j].Incidencias.push(element);
          }
        }
      }
    },
    /**
     * Obtiene los Trabajadores con marcajes en la linea de producción seleccionada.
     */
    async GetLineWorkers() {
      Log(this, this.GetLineWorkers.name);
      const self = this;
      self.showPreloadWorkerLine = true;
      self.showPreloadActivitiesLine = true;
      self.showPreloadTurnLine = true;
      self.disabledElementFrm = true;
      const currentDate = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD HH:mm:ss',
      );
      await this.Conections_GetLineWorkersToDate(
        this.selectedProductionLine.Id,
        currentDate,
      )
        .then((data) => {
          self.workerElementProduction = Array.isArray(data) ? data : [];
          for (let i = 0; i < self.workerElementProduction.length; i += 1) {
            self.workerElementProduction[i].Incidencias = [];
          }
          // Seleccionamos todos
          self.checkAllWorkerElementProduction = true;
          self.SortListWorkerElementProduction(self.sortFieldSelected);
          // self.GetPhotosProfileSubjects();
        })
        .finally(() => {
          self.showPreloadWorkerLine = false;
          self.showPreloadActivitiesLine = false;
          self.showPreloadTurnLine = false;
          self.disabledElementFrm = false;
        });
    },
    /*
     * Obtiene las actividades de producción en las que existen
     * marcajes de trabajadores de esta linea de producción
    GetProductionActivitiesXProductionLineToDate() {
      Log(this, this.GetProductionActivitiesXProductionLineToDate.name);
      const self = this;
      self.showPreloadActivitiesLine = true;
      self.disabledElementFrm = true;
      const currentDate = HiDateTimeSupport.FormatDateTime(
        Date.now(),
        'YYYY-MM-DD HH:mm:ss',
      );
      this.Conections_GetProductionActivitiesXProductionLineToDate(
        this.selectedProductionLine.Id,
        currentDate,
      )
        .then((data) => {
          this.activitiesProductionWithInterventions = data;
          // Seleccionamos todos
          self.checkAllActivitysLine = true;
        })
        .finally(() => {
          self.showPreloadActivitiesLine = false;
          self.disabledElementFrm = false;
        });
    },
    */
    async GetPhotosProfileSubjects() {
      Log(this, this.GetPhotosProfileSubjects.name);
      const arrSubjects = this.workerElementProduction.map(
        (w) => w.Trabajador.Sujeto,
      );
      await this.Conections_GetPhotosProfileSubjects(arrSubjects)
        .then((data) => {
          if (data.length > 0) {
            this.workerElementProduction.forEach((e) => {
              const objImg = data.find((s) => s.Id === e.Trabajador.Sujeto.Id);
              e.Trabajador.Sujeto.ImagenPerfil = objImg.ImagenPerfil;
            });
          }
        })
        .finally(() => {
          // this.uploadingPhotoProfileSubject = false;
        });
    },

    ChangedDateNewRecordWorkers(newDateValue) {
      Log(this, this.ChangedDateNewRecordWorkers.name);
      this.dateNewRecordsWorkers = HiDateTimeSupport.FormatDateTime(
        newDateValue,
        'YYYY-MM-DD',
      );
    },
    ChangeTimeNewRecordWorkers(newTimeValue) {
      Log(this, this.ChangeTimeNewRecordWorkers.name);
      this.timeNewRecordsWorkers = newTimeValue;
    },
    NewRecordSelectedWorker() {
      Log(this, this.NewRecordSelectedWorker.name);
      if (this.numberOfWorkersSelected === 0) {
        HiNotification.Toast('Es necesario seleccionar al menos a un trabajador para continuar.', 6000);
        /*
        HiNotification.Alert(
          'Es necesario seleccionar al menos a un trabajador para continuar.',
          'Selecciona al menos un trabajador',
        );
        */
        return;
      }

      if (this.selectedActivityNewRecords == null) {
        /*
        HiNotification.Alert(
          'Es necesario seleccionar una actividad de producción para los nuevos marcajes.',
          'Selecciona una actividad',
        );
        */
        HiNotification.Toast('Es necesario seleccionar una actividad de producción para los nuevos marcajes.', 6000);
        return;
      }
      this.dateTimeNewRecord = new Date(
        `${this.dateNewRecordsWorkers} ${this.timeNewRecordsWorkers}`,
      );
      const listObjMarcaje = [];
      this.workerElementProductionSelected.forEach((item) => {
        if (item.checked) {
          /** @type {PartialDeep<MarcajeCerco>} */
          const objMarcaje = {
            Id: 0,
            Trabajador: item.Trabajador,
            ActividadProduccion: this.selectedActivityNewRecords,
            LineaProduccion: {},
            FechaHora: HiDateTimeSupport.FormatDateTime(this.dateTimeNewRecord, ''),
          };
          listObjMarcaje.push(objMarcaje);
        }
      });
      const self = this;
      HiDialog.Preloader(true, 'Guardando marcaje');
      this.Conections_MakeNewRecordWorker(listObjMarcaje).then(() => {
        HiNotification.Toast('Marcajes realizados correctamente.', 6000);
        this.GetMainData(false);
      }).catch((recordsSuccess) => {
        self.ProcessWrongRecords(recordsSuccess);
        HiNotification.Toast('Algunos de los marcajes no se realizó correctamente. Ya hay un marcaje para la misma actividad, fecha y hora.', 6000);
        // HiNotification.Alert('Alguno de los marcajes no se realizó correctamente. Ya hay un marcaje para la misma actividad, fecha y hora.', 'Algún marcaje no se realizó');
      }).finally(() => {
        HiDialog.Preloader(false);
      });
    },
    /**
     *  Muestra los marcajes que al realizarlos han producido error
     */
    ProcessWrongRecords(recordsSuccess) {
      Log(this, this.ProcessWrongRecords.name);
      this.ClearWrongRecords();
      // Aplicamos los nuevos mensajes de errror.
      this.workerElementProductionSelected.forEach((t) => {
        const worker = recordsSuccess.find(
          (r) => r.Trabajador.Id === t.Trabajador.Id,
        );
        if (worker === undefined) {
          t.lastRecordError = true;
        }
      });
    },
    /**
     * Sets the last record error.
     *
     * @param {object} params
     * @param {Record<string, any>} params.item
     * @param {string} params.textError
     * @returns {void}
     */
    SetItemLastRecordError({ item, textError }) {
      if (!item) {
        return;
      }

      item.lastRecordError = true;
      item.lastRecordErrorText = textError;
    },
    NewRecordEndOfActivitySelectedWorker() {
      Log(this, this.NewRecordEndOfActivitySelectedWorker.name);
      let validationError = false;
      this.ClearWrongRecords();
      if (this.numberOfWorkersSelected === 0) {
        HiNotification.Toast('Es necesario seleccionar al menos a un trabajador para generar el marcaje.', 6000);
        /*
        HiNotification.Alert(
          'Es necesario seleccionar al menos a un trabajador para generar el marcaje.',
          'Selecciona al menos un trabajador.',
        );
        */
        return;
      }
      this.dateTimeNewRecord = new Date(
        `${this.dateNewRecordsWorkers} ${this.timeNewRecordsWorkers}`,
      );
      const listObjMarcaje = [];
      this.workerElementProductionSelected.forEach((item) => {
        if (item.checked) {
          /** @type {PartialDeep<MarcajeCerco>} */
          const objMarcaje = {
            Id: 0,
            Trabajador: item.Trabajador,
            ActividadProduccion: item.ActividadProduccion,
            LineaProduccion: this.selectedProductionLine,
            FechaHora: HiDateTimeSupport.FormatDateTime(this.dateTimeNewRecord, ''),
          };
          /* Pre-Marking Validations */
          // -- 1º  The end of activity cannot be before the start of activity
          let valid = true;
          if (objMarcaje.FechaHora <= item.FechaInicio) {
            valid = false;
            validationError = true;
            this.SetItemLastRecordError({ item, textError: 'El final de la actividad tiene una fecha inferior' });
          }
          if (valid) {
            listObjMarcaje.push(objMarcaje);
          }
        }
      });
      if (validationError) {
        HiNotification.Toast('Finalización de actividad no realizada. Revisa los mensajes de incidencia.', 6000);
        return; // No procesamos ninguno.
      }
      const self = this;
      HiDialog.Preloader(true, 'Finalizando Actividad trabajadores');

      this.Conections_MakeNewRecordWorker(listObjMarcaje).then(() => {
        HiNotification.Toast('La actividad ha finalizado correctamente.', 6000);
        this.GetMainData(false);
      }).catch((recordsSuccess) => {
        self.ProcessWrongRecords(recordsSuccess);
        HiNotification.Toast('Alguno de los marcajes de fin de jornada no se realizó correctamente.', 6000);
        // HiNotification.Alert(this, 'Alguno de los marcajes de fin de jornada no se realizó correctamente.', 'Algún marcaje falló');
      }).finally(() => {
        HiDialog.Preloader(false);
      });
    },
    /**
     * Elimina la marca del último marcaje erróneo
     */
    ClearWrongRecords() {
      Log(this, this.ClearWrongRecords.name);
      this.workerElementProduction.forEach((t) => {
        t.lastRecordError = false;
      });
    },
    ShowDetailWorker(objWorker, incidencesWorker) {
      Log(this, this.ShowDetailWorker.name);
      this.popupShowDetailWorkerRecords = true;
      this.selectedWorker = objWorker;
      this.selectedWorkerIncidences = incidencesWorker;
    },
    ClosePopupDetailWorkerRecords() {
      this.selectedWorker = null;
      this.popupShowDetailWorkerRecords = false;
    },
    GetNumberOfWorkersByActivity(objActivity) {
      Log(this, this.GetNumberOfWorkersByActivity.name);
      return this.workerElementProduction.filter(
        (element) => element.ActividadProduccion.Id === objActivity.Id,
      ).length;
    },
    GetNumberOfWorkersByTurn(objTurn) {
      Log(this, this.GetNumberOfWorkersByTurn.name);
      return this.workerElementProduction.filter(
        (element) => element.TurnoHorario != null && element.TurnoHorario.Codigo === objTurn.Codigo,
      ).length;
    },
    ChangeActivitieSelected(objActivity) {
      Log(this, this.ChangeActivitieSelected.name);
      this.workerElementProduction.forEach((e) => {
        if (e.ActividadProduccion.Id === objActivity.Id) {
          e.ActividadProduccion.checked = objActivity.checked;
        }
      });
    },
    ChangeTurnSelected(objTurn) {
      Log(this, this.ChangeTurnSelected.name);
      this.workerElementProduction.forEach((e) => {
        if (e.TurnoHorario.Codigo === objTurn.Codigo) {
          e.TurnoHorario.checked = objTurn.checked;
        }
      });
    },
    EventChangeSortField(val) {
      Log(this, this.EventChangeSortField.name);
      this.SortListWorkerElementProduction(val);
      this.sortFieldSelected = val;
    },
    RequestWorkersOutputLine() {
      Log(this, this.RequestWorkersOutputLine.name);
      // Si la linea de producción no tiene Zonas autorizadas para enviar trabajadores no permito enviarlos.
      if (this.selectedProductionLine != null && this.selectedProductionLine.ZonasAutorizadasAseos.length === 0) {
        HiNotification.Toast('Esta linea de producción no permite enviar trabajadores al aseo', 6000);
        return;
      }
      if (this.workerElementProductionSelected.length === 0) {
        // HiNotification.Alert('No has seleccionado ningún trabajador', 'Petición Aseos');
        HiNotification.Toast('No has seleccionado ningún trabajador', 6000);
      }
      this.$refs.PCProductionLineOutputAuthorizations?.AddWorkers(
        this.workerElementProductionSelected.map(
          (workerInLine) => workerInLine.Trabajador,
        ),
      );
    },
    /** Method NewUpdateTimer  */
    NewUpdateTimer() {
      Log(this, this.NewUpdateTimer.name);
      if (!this.automaticUpdateEnabled) {
        return;
      }
      const self = this;
      this.updateTimer = setInterval(() => {
        if (!this.automaticUpdate) {
          this.RemoveIntervalAutomaticUpdates();
          return;
        }
        if (self.selectedProductionLine === null
          || this.popupShowDetailWorkerRecords
          || this.popupShowDetailWorkerRecordsShowPreload
          || this.popupShowChangeProductionLineWorkers
          || this.popupShowNewMarkingForDifferentWorker) {
          return;
        }
        self.GetMainData(true);
      }, this.automaticUpdateInterval * 1000);
    },
    /** Method RemoveIntervalAutomaticUpdates  */
    RemoveIntervalAutomaticUpdates() {
      Log(this, this.RemoveIntervalAutomaticUpdates.name);
      clearInterval(this.updateTimer);
    },
    OpenNewWorkerRecord() {
      Log(this, this.OpenNewWorkerRecord.name);
      this.popupShowNewMarkingForDifferentWorker = true;
      // this.$refs.PCNewWorkerRecord.Reset();
    },
    /** Method RecalculateCurrentAndPreviousDays  */
    async RecalculateCurrentAndPreviousDays() {
      Log(this, this.RecalculateCurrentAndPreviousDays.name);
      HiDialog.Preloader(true, 'Recalculando días');
      await APIErp.callRecalculateCurrentAndPreviousDays(this.selectedProductionLine.Id, HiDateTimeSupport.FormatDateTime(HiDateTimeSupport.AddHoursAndMinutes(new Date(), -24, 0), 'YYYY-MM-DD'));
      HiDialog.Preloader(false);
      this.GetMainData(false);
    },
    /** Method RecordRemoved  */
    RecordRemoved() {
      Log(this, this.RecordRemoved.name);
      this.GetMainData(false);
    },
    /** Method RequestCaptureServiceRestart  */
    RequestCaptureServiceRestart() {
      Log(this, this.RequestCaptureServiceRestart.name);
      this.$refs.confirmationComponent.create(
        'Reiniciar Servicio de Captura de Marcajes',
        'Esta acción reiniciará el servicio de captura de marcajes del servidor. Todos los terminales estarán sin capturar mientras se completa la acción. ¿Deseas continuar con la acción?',
        async () => {
          HiDialog.Preloader(true, 'Reiniciando servicio de captura de marcajes');

          /** @type {import('@/js/common/HiNotificationExSupport').ShowToastParameters} */
          const notificationConfig = {
            title: 'Servicio de captura de marcajes',
            horizontalPosition: 'right',
            typeIcon: true,
            closeButton: true,
            closeTimeout: 6000,
          };

          try {
            const result = await this.Conections_CaptureServiceRestart();
            HiDialog.Preloader(false);

            if (result && (result.statusText === 'OK' || result.status === 200) && result.data && result.data.valor) {
              notificationConfig.text = 'El servicio de captura de marcajes se reinició con éxito. En unos segundos volverá a estar operativa la captura de marcajes en tiempo real';
              notificationConfig.type = 'success';
            } else {
              notificationConfig.text = result && result.data ? result.data.mensaje : 'El servicio de captura de marcajes no pudo ser reiniciado. Contacta con tu administrador para resolver el problema.';
              notificationConfig.type = 'danger';
            }
          } catch {
            HiDialog.Preloader(false);
            HiNotification.Toast('Ocurrió un error al reiniciar el servicio. Contacta con tu administrador.', 6000);
          }

          showToast(notificationConfig);
        },
      );
      this.$refs.confirmationComponent.show();
    },
    /* ****************** CONNECTIONS  ********************* ** */
    /* ********************************************************* */
    ActivityCodeSearch(params) {
      Log(this, this.ActivityCodeSearch.name);
      return APIErp.callProductionActivitySearchCode(params);
    },
    ActivityList() {
      Log(this, this.ActivityList.name);
      return APIErp.callProductionActivityListXLineAuthorized(
        this.selectedProductionLine.Id,
      );
    },
    ProductionLineCodeSearch(params) {
      Log(this, this.ProductionLineCodeSearch.name);
      return APIErp.callProductionLineSearchCode(params);
    },
    ProductionLineList() {
      Log(this, this.ProductionLineList.name);
      // return APIErp.callProductionLineList();
      return APIErp.callProductionLineListAuthorized();
    },
    Conections_GetLineWorkersToDate(idLine, dateOfconsult) {
      return new Promise((resolve, reject) => {
        callLineWorkersToDate(idLine, dateOfconsult)
          .then((result) => {
            resolve(result.data);
            // resolve([{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false},{"Id":66996,"Trabajador":{"Id":2,"Codigo":"46500050001","Sujeto":{"Id":2942,"Identificador":"45582142Y","TipoIdentificador":"NIF","NombreSujeto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","PrimerApellido":".","SegundoApellido":"","NombreCompleto":". , JUAN MIRANDA BERENGUEL--HISPATEC PRUEBA-","RazonSocial":null,"FechaNacimiento":"1900-01-01T00:00:00","TipoSujeto":"PersonaFisica","ImagenPerfil":null},"EsResponsableProyecto":false,"EsResponsableLinea":false},"LineaProduccion":null,"ActividadProduccion":{"Id":10,"Nombre":"PEPINO","Codigo":"PEP","Productiva":true,"Regularizacion":false,"ModoMarcaje":1},"FechaInicio":"2022-01-31T10:41:00","FechaFin":"2022-01-31T16:18:00","FueraDeLinea":false}]);
          })
          .catch((error) => {
            reject(error);
            LogError(this, this.Conections_GetLineWorkersToDate.name, error);
          });
      });
    },
    Conections_MakeNewRecordWorker(listObjMarcaje) {
      Log(this, this.Conections_MakeNewRecordWorker.name);
      return new Promise((resolve, reject) => {
        APIErp.callMakeNewRecordsWorkers(listObjMarcaje)
          .then((result) => {
            if (result.data.valor) {
              resolve();
            } else {
              reject(result.data.tag); // Alguno de los marcajes no se ha realizado correctamente.
            }
          })
          .catch((error) => {
            LogError(this, this.Conections_MakeNewRecordWorker.name, error);
          });
      });
    },
    Conections_GetPhotosProfileSubjects(arrObjSubjects) {
      return new Promise((resolve, reject) => {
        callGetPhotosProfileSubjects(arrObjSubjects)
          .then((result) => {
            resolve(result.data);
          })
          .catch((error) => {
            LogError(
              this,
              this.Conections_GetPhotosProfileSubjects.name,
              error,
            );
            reject();
          });
      });
    },
    Conections_CaptureServiceRestart() {
      Log(this, this.Conections_CaptureServiceRestart.name);
      return APIErp.callResetProcess('HispatecCapturaMarcajesService');
    },
    /* ********************************************************************************************* */
    /* *********************** Fin Metodos de conexion con ERP ************************************ */
    /* ********************************************************************************************* */
    isMobile() {
      if (window.innerWidth < 768) {
        return true;
      }
      return false;
    },
    SortListWorkerElementProduction(val) {
      Log(this, this.SortListWorkerElementProduction.name);
      switch (val.AssociatedFilterProperty) {
        case 'FechaInicio':
          this.workerElementProduction = this.workerElementProduction.sort(
            (a, b) => {
              if (a[val.AssociatedFilterProperty] < b[val.AssociatedFilterProperty]) {
                return -1;
              }
              if (a[val.AssociatedFilterProperty] > b[val.AssociatedFilterProperty]) {
                return 1;
              }
              return 0;
            },
          );
          break;
        case 'Trabajador.Sujeto.NombreCompleto':
          this.workerElementProduction = this.workerElementProduction.sort(
            (a, b) => {
              if (a.Trabajador.Sujeto.NombreCompleto < b.Trabajador.Sujeto.NombreCompleto) {
                return -1;
              }
              if (a.Trabajador.Sujeto.NombreCompleto > b.Trabajador.Sujeto.NombreCompleto) {
                return 1;
              }
              return 0;
            },
          );
          break;
        case 'ActividadProduccion.Nombre':
          this.workerElementProduction = this.workerElementProduction.sort(
            (a, b) => {
              if (a.ActividadProduccion.Nombre < b.ActividadProduccion.Nombre) {
                return -1;
              }
              if (a.ActividadProduccion.Nombre > b.ActividadProduccion.Nombre) {
                return 1;
              }
              return 0;
            },
          );
          break;
        default:
          this.workerElementProduction = this.workerElementProduction.sort(
            (a, b) => a.Id - b.Id,
          );
          break;
      }
    },
  },
};
</script>

<style scoped  lang="scss">
.content-grid {
  display: grid;
  row-gap: 2vh;
  grid-template-columns: 0.8fr 2fr 1.2fr;
  column-gap: 1vw;
}

.content-grid > div:nth-child(1) {
  grid-column: span 1;
}

.content-grid > div:nth-child(2) {
  grid-column: span 1;
  grid-row: 2 span;
}

.popup-detalle-marcajes-errores {
  background: var(--his-tomate-light);
  display: flex;
  padding: 7px;
  font-size: 14px;
  font-weight: 500;

  img {
    margin-right: 15px;
  }

  span {
    font-family: var(--hi-font-family);
  }
}

.main-productive-activity-line {
  // TODO: Remove when migrated to new styles
  --f7-button-height: 44px;
  --f7-button-small-height: 40px;

  --f7-input-outline-height: 40px;
  --f7-list-item-min-height: 48px;
  --f7-list-item-padding-horizontal: 16px;
  --f7-input-font-size: 16px;
  --f7-label-font-size: 12px;
  --f7-label-line-height: 1.3;

  --f7-checkbox-inactive-color: var(--his-silver);
  --f7-checkbox-active-color: var(--his-greenlight);
  --f7-checkbox-border-width: 1px;
  --f7-checkbox-border-radius: 6px;

  --f7-badge-bg-color: #616d82;
  --f7-badge-size: 25px;
  --f7-badge-font-size: 14px;
  --f7-badge-font-weight: 700;
  --f7-badge-padding: 0 4px;
  --f7-card-header-font-size: 16px;
  --f7-card-header-font-weight: 400;
  --f7-card-header-min-height: 30px;

  :deep(.card) {
    border: 1px solid var(--f7-card-outline-border-color);
  }

  :deep(.card-header) {
    font-size: var(--f7-card-header-font-size);
    font-weight: var(--f7-card-header-font-weight);
    min-height: var(--f7-card-header-min-height);
    padding: var(--f7-card-header-padding-vertical) var(--f7-card-header-padding-horizontal);
    letter-spacing: 0;
  }

  :deep(.icon-checkbox, .checkbox i) {
    background-color: transparent;
  }
  //
}

.main-productive-activity-line,
.panel {
  height: 120vh;
  overflow-x: hidden;
  overflow-y: hidden;

  .scroll-pane {
    overflow-y: scroll;
    scrollbar-width: auto;
    height: 75vh;
  }

  .content-header-activity-line {
    --search-input-color: var(--his-steel-blue);
    --search-input-padding-left: 32px;

    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;
    padding: 8px 0 10px;
    margin-bottom: 6px;

    .block-title {
      display: none;
    }

    .content-searcher-erp {
      &__input {
        margin: 0 5px;
      }
    }
  }

  .badge {
    height: 22px;
    width: 22px;
    font-size: 15px;
    background: #e4e4e4;
    color: var(--his-metal);
    font-weight: 500;
    margin-left: 4px;
  }

  .card {
    margin: 0;

    .card-header {
      background-color: #ebecf0;
      text-transform: uppercase;
      color: #253858;
      font-weight: 400;
    }
  }

  .content-list-checkbox-item,
  .content-title-select {
    padding: 7px 15px;
    background: #f4f5f7;
    margin-bottom: 2px;
    border: 1px solid #ebebed;
    border-radius: 3px;

    &.incidence {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #ff5630;
    }

    &.out-of-line {
      background: rgb(222 53 11 / 10%);
      border: 1px solid #fcff30;
    }
  }

  .content-list-checkbox-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > div {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    label {
      margin-right: 10px;
    }

    &__details {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 16px;

      &--title {
        color: var(--his-dark-blue);
      }

      &--subtitle {
        color: var(--his-kiwi-pulp);
        text-transform: uppercase;
      }

      img {
        border-radius: 50%;
        margin: 0 10px 0 0;
        width: 64px;
        height: 64px;
      }

      &--total {
        display: flex;

        img {
          height: 20px;
          width: 20px;
          margin: 0;
          padding: 0 0 0 5px !important;
          border-radius: 0;
        }
      }
    }

    &__warning {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    &__time {
      color: var(--his-slate-blue);
      font-size: 28px;
      display: flex;
      align-items: center;

      &::after {
        font-family: "framework7-core-icons";
        font-weight: normal;
        direction: ltr;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        -moz-font-feature-settings: "liga";
        font-feature-settings: "liga";
        text-align: center;
        display: block;
        margin-left: 15px;
        font-size: var(--f7-list-chevron-icon-font-size);
        color: var(--f7-list-chevron-icon-color);
        pointer-events: none;
        right:
          calc(
            var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-right)
          );
        content: var(--f7-list-chevron-icon-right);
      }
    }

    &.checked {
      background-color: var(--his-steel-blue);
      color: #fff;

      .badge {
        background-color: #253858;
        color: #fff;
      }
    }
  }

  .content-title-select {
    display: flex;
    align-items: center;

    /* justify-content: space-between */
    &__input {
      display: flex;
      align-items: center;
      color: var(--his-steel-blue);
      font-weight: 400;
      font-size: 15px;
      text-transform: uppercase;

      label {
        margin-right: 12px;
      }
    }

    .input-filter {
      margin-left: auto;
    }
  }

  .content-new-activity {
    &__datetime {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > div {
        width: 100%;
      }

      > div:first-child {
        margin-right: 15px;
      }

      > div:nth-child(2) {
        max-width: 120px !important;
      }

      input {
        color: var(--his-dark-blue);
        font-weight: 500;
        font-size: 16px;
      }
    }
  }

  label.item-checkbox input[type="checkbox"]:checked ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:checked ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:checked ~ i,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ .icon-checkbox,
  label.item-checkbox input[type="checkbox"]:indeterminate ~ * .icon-checkbox,
  .checkbox input[type="checkbox"]:indeterminate ~ i {
    background-color: #566784;
    border-color: #566784;
    zoom: 1.3;
  }

  .icon-checkbox {
    zoom: 1.3;
  }

  .actions-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

a.panel-close {
  background: var(--his-dark-blue);
  display: flex;
}

.ios .icon-checkbox,
.ios .checkbox i {
  zoom: 1.1 !important;
}

@media (max-width: 1024px) {
  .content-grid {
    grid-template-columns: 1fr 2fr;
  }

  .content-logo-hispatec {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr 3fr !important;
  }
}

@media (max-width: 768px) {
  .content-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 530px) {
  .content-logo-company {
    display: none;
  }

  .content-header-activity-line {
    grid-template-columns: 1fr !important;
  }

  .content-list-checkbox-item__details {
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .content-list-checkbox-item__time {
    font-size: 18px !important;
    font-weight: 600;
    padding-left: 10px;
  }

  .content-list-checkbox-item__details img.avatar-round {
    width: 48px !important;
    height: 48px !important;
  }
}

.span-text-error {
  color: red;
  font-size: 11px;
  opacity: 0.7;
}

.content-list-checkbox-scroll {
  height: 65vh;
  overflow-y: auto;
}

.new-mark-worker-popup {
  height: 95vh;
}

.card-content_activities {
  height: 25vh;
  overflow-y: auto;
}

.card-content_turn {
  height: 25vh;
  overflow-y: auto;
}
</style>
